<template>
  <transition name="modal" @before-enter="onBeforeEnter" @after-leave="onAfterLeave">
    <div v-if="isVisible" :class="['holiday-search-modal-overlay', { 'd-flex': isVisible }, {'active-search': isDropdownOrAutoCompleteOpen}]">
      <div class="holiday-search-modal-intro" @click="closeModal">
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <picture>
                <img :src="`${logo}?format=webp`" :alt="logoAlt" class="holiday-search-modal-logo" loading="lazy"/>
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
            <div class="col">
              <div class="holiday-search-modal">
                <button class="close-button" @click="closeModal" aria-label="Close the modal" title="Close the modal">
                  <span>close</span>

                  <svg id="Close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
                    <path id="Path_4605" data-name="Path 4605" d="M12.3,13.7.3,1.7A.967.967,0,0,1,.3.3h0A.967.967,0,0,1,1.7.3l12,12a.967.967,0,0,1,0,1.4h0A.967.967,0,0,1,12.3,13.7Z" fill="#A9378C"/>
                    <path id="Path_4606" data-name="Path 4606" d="M.3,12.3l12-12a.967.967,0,0,1,1.4,0h0a.967.967,0,0,1,0,1.4l-12,12a.967.967,0,0,1-1.4,0h0A.967.967,0,0,1,.3,12.3Z" fill="#A9378C"/>
                  </svg>
                </button>

                <div class="holiday-search-modal-content">
                  <holiday-search 
                    :action="action"
                    :auto-complete-url="autoCompleteUrl"
                    :show-departure-filter="showDepartureFilter"
                    :where-name="whereName"
                    :where-description="whereDescription"
                    :onclick-placeholder="onclickPlaceholder"
                    :when-name="whenName"
                    :when-description="whenDescription"
                    :how-name="howName"
                    :travel-style-description="travelStyleDescription"
                    :departure-description="departureDescription"
                    @toggle-open="setDropdownOrAutoCompleteOpen">
                  </holiday-search>

                  <slot></slot>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import EventBus from '@/vue/EventBus';
import HolidaySearch from './HolidaySearch.vue';

export default {
  name: 'HolidaySearchModal',
  components: {
    HolidaySearch
  },
  props: {
    logo: {
      type: String,
      required: true
    },
    logoAlt: {
      type: String,
      required: true
    },
    action: {
      type: String,
      default: ''
    },
    autoCompleteUrl: {
      type: String,
      default: '/umbraco/api/search/Suggest'
    },
    whereName: {
      type: String,
      default: 'SearchTerm'
    },
    whereDescription: {
      type: String,
      default: 'Where would you like to go?'
    },
    onclickPlaceholder: {
      type: String,
      default: 'Type your holiday'
    },
    whenName: {
      type: String,
      default: 'Dates'
    },
    whenDescription: {
      type: String,
      default: 'When would you like to go?'
    },
    howName: {
      type: String,
      default: 'Types'
    },
    travelStyleDescription: {
      type: String,
      default: 'What\'s your travel style?'
    },
    departureName: {
      type: String,
      default: 'Departs'
    },
    departureDescription: {
      type: String,
      default: 'Departure Airport?'
    },
    showDepartureFilter: {
      type: Boolean, 
      default: true
    }
  },
  data() {
    return {
      isVisible: false,
      isDropdownOrAutoCompleteOpen: false
    };
  },
  methods: {
    closeModal() {
      this.isVisible = false;
    },
    openModal() {
      this.isVisible = true;
    },
    setDropdownOrAutoCompleteOpen(isOpen) {
      this.isDropdownOrAutoCompleteOpen = isOpen;
    },
    onBeforeEnter() {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.style.overflow = 'hidden';
    },
    onAfterLeave() {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '';
    }
  },
  created() {
    EventBus.$on('open-search-modal', this.openModal);
  },
  beforeDestroy() {
    EventBus.$off('open-search-modal', this.openModal);
  },
};
</script>